import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Intro from "./components/Intro";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import ChatPopup from "./components/ChatPopup";
import SplashScreen from "./components/SplashScreen";
import Highlights from "./components/Highlights";
import CallToAction from "./components/CallToAction";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  const [progress, setProgress] = useState(0);
  const [isExiting, setIsExiting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const progressTimer = setInterval(() => {
      setProgress((prev) =>
        prev >= 100 ? 100 : Math.min(prev + Math.random() * 16 + 8, 100)
      );
    }, 200);

    const exitTimer = setTimeout(() => setIsExiting(true), 1800);
    const doneTimer = setTimeout(() => setIsLoading(false), 2300);

    return () => {
      clearInterval(progressTimer);
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isLoading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);

  return (
    <LanguageProvider>
      {isLoading && <SplashScreen progress={progress} isExiting={isExiting} />}
      <main>
        <ChatPopup />
        <Navbar />
        <Intro />
        <Highlights />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <CallToAction />
        <Contact />
      </main>
    </LanguageProvider>
  );
}

export default App;
